import { render } from "./MainLayout.vue?vue&type=template&id=54e57380"
const script = {}

import exportComponent from "/mnt/d/Projetos/Carneiros Temporada/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__